import * as AF from "src/types/formTemplate";
import { z } from "zod";
import * as DateConstraints from "./DateConstraints";
import * as NumberConstraints from "./NumberConstraints";

export const FormikSchema = DateConstraints.FormikSchema.and(
  NumberConstraints.FormikSchema
);
export type FormikType = z.infer<typeof FormikSchema>;

export function toFormValue(question: AF.V2.Question): FormikType {
  if (question.type === "Date") {
    return {
      ...EmptyFormikValue,
      ...DateConstraints.toFormValue(question),
    };
  }

  if (question.type === "Number") {
    return {
      ...EmptyFormikValue,
      numberFormat: question.constraints?.format,
      numberPrecision: question.constraints?.precision ?? undefined,
      numberConstraints: {
        switch:
          question.constraints?.minValue && question.constraints.maxValue
            ? "on"
            : "off",
        minValue: question.constraints?.minValue,
        maxValue: question.constraints?.maxValue,
      },
      type: question.type,
    };
  }

  return {
    ...EmptyFormikValue,
    type: question.type,
  };
}

export const EmptyFormikValue: FormikType = {
  ...DateConstraints.EmptyFormikValue,
  numberConstraints: {
    switch: "off",
  },
};
